import { Types } from '@fiverr-private/theme';
import { resetGlobalUlPadding } from './styles.ve.css';

export const generateDefaultPadding = ({ padding, paddingLeft, paddingX }: Types.BoxType) =>
    padding || paddingLeft || paddingX ? '' : resetGlobalUlPadding;
